export const THANKYOU_PAGE_API = {
  create: "host/thankyou/page/add",
  is_page_available: "host/thankyou/page/get",
  get_sections_config: "host/thankyou/page/sections/details",
  get_sections_data: "host/thankyou/page/section/list",
  add_sections_data: "host/thankyou/page/section/create",
  get_pages_list: "host/thankyou/page/list",
};
